import PropTypes from 'prop-types';
export const meal = PropTypes.shape({
    name: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    protein: PropTypes.number,
    energy: PropTypes.number,
    fat: PropTypes.number
});
export const activity = PropTypes.shape({
    name: PropTypes.string.isRequired,
    // type     : PropTypes.string,
    timestamp: PropTypes.number.isRequired,
    duration: PropTypes.number,
    value: PropTypes.number
});
export const pill = PropTypes.shape({
    name: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    unit: PropTypes.string.isRequired
});
export const injection = PropTypes.shape({
    timestamp: PropTypes.number.isRequired
});
